import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { selectBranchesWithUserData } from '../../store/slices/branch.slice';
import { BranchWithUserData } from '../../commonTypes/acs';

export const useBranchesWithUserData = () => {
    return useSelector<RootState, BranchWithUserData[]>(selectBranchesWithUserData);
};
